'use client'
import DealCard from './DealCard'

export default function TrendingDealCard({ deal, locked = false }) {
  return <DealCard deal={deal} locked={locked} showGoogleFlights={false} sparklinePrices={[]} />
}
